import React, { useState } from "react";
import "./style.css";

const FAQ = () => {
	const [openIndex, setOpenIndex] = useState(null)

	const faqs = [
		{
			question: "What services does Big Cat Graphics offer?",
			answer:
				"We offer a comprehensive range of creative services including graphic design, branding, VFX, CGI, photography, and visual content creation for artists, brands, and businesses of all sizes.",
		},
		{
			question: "How long does a typical project take?",
			answer:
				"Project timelines vary depending on scope and complexity. Simple designs can be completed within a few days, while comprehensive branding or VFX projects may take several weeks. We'll provide a detailed timeline during our initial consultation.",
		},
		{
			question: "Do you work with international clients?",
			answer:
				"Yes! We work with clients worldwide. Our digital workflow allows us to collaborate seamlessly regardless of location, ensuring consistent communication and quality throughout your project.",
		},
		{
			question: "What is your design process?",
			answer:
				"Our process begins with understanding your vision and goals. We then develop concepts, gather feedback, refine designs, and deliver final assets. Throughout the journey, we maintain clear communication and ensure your complete satisfaction.",
		},
		{
			question: "Can you handle both small and large projects?",
			answer:
				"Absolutely! We're equipped to handle projects of any scale, from individual artist portfolios to large corporate campaigns. Every project receives the same level of dedication and craftsmanship.",
		},
		{
			question: "What makes Big Cat Graphics different?",
			answer:
				"Our unique combination of artistic creativity, technical expertise in VFX/CGI, and proven track record with renowned artists and major brands sets us apart. We don't just create visuals—we bring visions to life.",
		},
		{
			question: "How do you ensure that your designs meet user needs and business goals?",
			answer: "At Big Cat Graphics, we ensure our designs meet user needs and business goals through a client-focused, collaborative approach. We take the time to understand your brand, target audience, and objectives, allowing us to create visually compelling work that aligns with your vision. By incorporating user feedback and data-driven insights, we refine our designs to deliver both aesthetic appeal and measurable results. Our commitment to creativity, functionality, and consistency ensures that every project supports your business growth."
		},
		{
			question: "Do you offer freelance or contract design services?",
			answer: "Yes, we offer both freelance and contract design services to accommodate the diverse needs of our clients. Whether you require support for a one-time project or ongoing creative collaboration, we're flexible in providing tailored solutions. Our team is equipped to handle projects of any scale, ensuring high-quality results delivered on time and within budget."
		},
		{
			question: "What tools and software do you use for your design work?",
			answer: "For graphic design, we rely on Adobe Creative Suite, including Photoshop, Illustrator, and InDesign, Our video editing and VFX projects are handled using Adobe After Effects, Premiere Pro, and DaVinci Resolve, while CGI work is crafted with Blender, For photography, we utilize Adobe Lightroom and Capture One to ensure flawless image editing and color grading. This diverse toolkit allows us to produce creative, polished results across all our services."
		},
		{
			question: "What is your design process, and how do you approach new projects?",
			answer: "Our design process begins with understanding the client's vision, goals, and target audience. We start with a discovery phase where we gather insights through discussions and research to ensure we're aligned with the project's objectives. From there, we move into the concept development stage, where we brainstorm ideas, create mood boards, and draft initial designs. Once we have a solid concept, we refine it through client feedback, making adjustments to ensure it meets both creative and strategic goals. Throughout the process, we maintain open communication to deliver a final product that is visually compelling, functional, and aligned with the client's brand."
		}
	]

	const toggleFAQ = (index) => {
		setOpenIndex(openIndex === index ? null : index)
	}

	return (
		<section className="faq-section">
			<div className="faq-container">
				<div className="faq-header">
					<h2>Frequently Asked Questions</h2>
					<p>Everything you need to know about working with us</p>
				</div>

				<div className="faq-list">
					{faqs.map((faq, index) => (
						<div key={index} className="faq-item">
							<button
								className={`faq-question ${openIndex === index ? "open" : ""}`}
								onClick={() => toggleFAQ(index)}
							>
								{faq.question}
								<span className="faq-icon">{openIndex === index ? "-" : "+"}</span>
							</button>

							<div
								className={`faq-answer ${openIndex === index ? "show" : ""}`}
							>
								<p>{faq.answer}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default FAQ;